export enum DonorTier {
  Bronze = 1,
  Silver,
  Gold,
  Platinum
}
export enum ContainerStatus {
  Available = 1,
  ReadyForSorting,
  Sorting,
  InUse
}
export enum ContainerDest {
  Production = 1,
  Reserve,
  Warehouse,
  Transfer,
  Salvage,
  Ecommerce
}
export enum ItemCondition {
  Sellable = 1,
  NeedsRefurbishment,
  Salvage,
  Dispose
}
export enum ContainerType {
  Gaylord = 1,
  CartRack,
  Pallet,
  Tote,
  Baler
}
export enum PresortMethod {
  DockSide = 1,
  Batch
}
export enum PresortStatus {
  Pending = 1,
  InProgress,
  Completed
}
export enum PaymentMethod {
  CreditCard = 1,
  DebitCard,
  ApplePay,
  GooglePay,
  Cash
}
export enum ReceiptDelivery {
  Email = 1,
  SMS,
  Print,
  None
}
export enum StoreStatus {
  Open = 1,
  Closed,
  Busy
}
export enum DonationRole {
  Attendant = 1,
  PresortWorker,
  Manager,
  Admin
}
export enum DonationStatus {
  Scheduled = 1,
  CheckedIn,
  Completed,
  Cancelled,
  NoShow
}
export enum DonationMethod {
  WalkIn = 1,
  Scheduled,
  Pickup
}
export enum DonationScope {
  Items = 1,
  Monetary,
  Both,
  Box = 4,
  Bag = 5,
  ByWeight = 6
}

export enum UnitType {
  PerUnit = 0,
  Lbs = 1,
  Amount = 2
}

export enum MeasurementType {
  Unit = 0,
  Weight = 1,
  Amount = 2
}

export enum SharedStoreStatus {
  Unknown = 0,
  Draft,
  Active,
  Inactive
}

// ── Phase 1 enums ────────────────────────────────────────────────────────────
export enum PointsCalcMethod {
  PerItem = 1,
  PerWeight
} // PerWeight disabled by default
export enum RewardType {
  Discount = 1,
  Cashback,
  Gift,
  Voucher
}
export enum RedemptionStatus {
  Pending = 1,
  Approved,
  Rejected,
  Fulfilled,
  Cancelled
}
export enum CampaignStatus {
  Draft = 1,
  Active,
  Paused,
  Completed
}
export enum NotificationChannel {
  Email = 1,
  SMS,
  Both
}

// ── Display label maps (used by components and templates) ────────────────────
export const DonorTierLabel: Record<DonorTier, string> = {
  [DonorTier.Bronze]: 'Bronze',
  [DonorTier.Silver]: 'Silver',
  [DonorTier.Gold]: 'Gold',
  [DonorTier.Platinum]: 'Platinum'
};
export const DonationStatusLabel: Record<DonationStatus, string> = {
  [DonationStatus.Scheduled]: 'Scheduled',
  [DonationStatus.CheckedIn]: 'Checked In',
  [DonationStatus.Completed]: 'Completed',
  [DonationStatus.Cancelled]: 'Cancelled',
  [DonationStatus.NoShow]: 'No Show'
};
export const ContainerStatusLabel: Record<ContainerStatus, string> = {
  [ContainerStatus.Available]: 'Available',
  [ContainerStatus.ReadyForSorting]: 'Ready for Sorting',
  [ContainerStatus.Sorting]: 'Sorting',
  [ContainerStatus.InUse]: 'In Use'
};
export const ContainerDestLabel: Record<ContainerDest, string> = {
  [ContainerDest.Production]: 'Production',
  [ContainerDest.Reserve]: 'Reserve',
  [ContainerDest.Warehouse]: 'Warehouse',
  [ContainerDest.Transfer]: 'Transfer',
  [ContainerDest.Salvage]: 'Salvage',
  [ContainerDest.Ecommerce]: 'E-Commerce'
};
export const ItemConditionLabel: Record<ItemCondition, string> = {
  [ItemCondition.Sellable]: 'Sellable',
  [ItemCondition.NeedsRefurbishment]: 'Needs Refurb',
  [ItemCondition.Salvage]: 'Salvage',
  [ItemCondition.Dispose]: 'Dispose'
};
export const ContainerTypeLabel: Record<ContainerType, string> = {
  [ContainerType.Gaylord]: 'Gaylord',
  [ContainerType.CartRack]: 'Cart / Rack',
  [ContainerType.Pallet]: 'Pallet',
  [ContainerType.Tote]: 'Tote / Bin',
  [ContainerType.Baler]: 'Baler'
};
export const PresortMethodLabel: Record<PresortMethod, string> = {
  [PresortMethod.DockSide]: 'Dock-Side',
  [PresortMethod.Batch]: 'Batch'
};
export const StoreStatusLabel: Record<StoreStatus, string> = {
  [StoreStatus.Open]: 'Open',
  [StoreStatus.Closed]: 'Closed',
  [StoreStatus.Busy]: 'Busy'
};
export const DonationMethodLabel: Record<DonationMethod, string> = {
  [DonationMethod.WalkIn]: 'Walk-in',
  [DonationMethod.Scheduled]: 'Scheduled',
  [DonationMethod.Pickup]: 'Pickup'
};
export const RewardTypeLabel: Record<RewardType, string> = {
  [RewardType.Discount]: 'Discount',
  [RewardType.Cashback]: 'Cashback',
  [RewardType.Gift]: 'Gift',
  [RewardType.Voucher]: 'Voucher'
};
export const RedemptionStatusLabel: Record<RedemptionStatus, string> = {
  [RedemptionStatus.Pending]: 'Pending',
  [RedemptionStatus.Approved]: 'Approved',
  [RedemptionStatus.Rejected]: 'Rejected',
  [RedemptionStatus.Fulfilled]: 'Fulfilled',
  [RedemptionStatus.Cancelled]: 'Cancelled'
};
export const CampaignStatusLabel: Record<CampaignStatus, string> = {
  [CampaignStatus.Draft]: 'Draft',
  [CampaignStatus.Active]: 'Active',
  [CampaignStatus.Paused]: 'Paused',
  [CampaignStatus.Completed]: 'Completed'
};
export const NotificationChannelLabel: Record<NotificationChannel, string> = {
  [NotificationChannel.Email]: 'Email',
  [NotificationChannel.SMS]: 'SMS',
  [NotificationChannel.Both]: 'Email & SMS'
};

// ── Missing label maps (V5 fix) ─────────────────────────────────────────────
export const PresortStatusLabel: Record<PresortStatus, string> = {
  [PresortStatus.Pending]: 'Pending',
  [PresortStatus.InProgress]: 'In Progress',
  [PresortStatus.Completed]: 'Completed'
};
export const PaymentMethodLabel: Record<PaymentMethod, string> = {
  [PaymentMethod.CreditCard]: 'Credit Card',
  [PaymentMethod.DebitCard]: 'Debit Card',
  [PaymentMethod.ApplePay]: 'Apple Pay',
  [PaymentMethod.GooglePay]: 'Google Pay',
  [PaymentMethod.Cash]: 'Cash'
};
export const ReceiptDeliveryLabel: Record<ReceiptDelivery, string> = {
  [ReceiptDelivery.Email]: 'Email',
  [ReceiptDelivery.SMS]: 'SMS',
  [ReceiptDelivery.Print]: 'Print',
  [ReceiptDelivery.None]: 'None'
};
export const DonationRoleLabel: Record<DonationRole, string> = {
  [DonationRole.Attendant]: 'Attendant',
  [DonationRole.PresortWorker]: 'Presort Worker',
  [DonationRole.Manager]: 'Manager',
  [DonationRole.Admin]: 'Admin'
};
export const DonationScopeLabel: Record<DonationScope, string> = {
  [DonationScope.Items]: 'Items',
  [DonationScope.Monetary]: 'Monetary',
  [DonationScope.Both]: 'Both',
  [DonationScope.Box]: 'Box',
  [DonationScope.Bag]: 'Bag',
  [DonationScope.ByWeight]: 'By Weight'
};
export const DonationScopeBadgeClass: Record<DonationScope, string> = {
  [DonationScope.Items]: 'badge-info',
  [DonationScope.Monetary]: 'badge-success',
  [DonationScope.Both]: 'badge-purple',
  [DonationScope.Box]: 'badge-warning',
  [DonationScope.Bag]: 'badge-purple',
  [DonationScope.ByWeight]: 'badge-gray'
};
export const UnitTypeLabel: Record<UnitType, string> = {
  [UnitType.PerUnit]: 'units',
  [UnitType.Lbs]: 'lbs',
  [UnitType.Amount]: 'amount'
};
export const PointsCalcMethodLabel: Record<PointsCalcMethod, string> = {
  [PointsCalcMethod.PerItem]: 'Per Item',
  [PointsCalcMethod.PerWeight]: 'Per Weight'
};

export enum PrinterType {
  Zebra = 1,
  Laser = 2
}

export enum CardOperationType {
  Unknown = 0,
  Sale = 1,
  Void = 2,
  Refund = 3
}

export enum CardOperationStatus {
  Unknown = 0,
  Pending = 1,
  Approved = 2,
  PartiallyApproved = 3,
  Declined = 4,
  TimedOut = 5,
  Cancelled = 6,
  Error = 7
}

export enum CardBrand {
  Unknown = 0,
  Visa = 1,
  Mastercard = 2,
  AmericanExpress = 3,
  Discover = 4,
  Other = 5
}

export enum CardEntryMethod {
  Unknown = 0,
  Tap = 1,
  Insert = 2,
  Swipe = 3,
  Manual = 4
}
